import { Setter } from 'utils'
import { ReactNode } from 'react'

export interface LoginSignUpProps {
  handleSubmit: (e: React.FormEvent) => void
  handleUpdate: (e: { value?: string; name: string }) => void
  form: FormData
  error?: string
  isLogin?: boolean
  isLoading: boolean
  isSsoLoginLoading?: boolean
  setIsPasswordValid?: Setter<boolean>
  onNextClick: () => void
  onPreviousClick: () => void
  isRegistrationInProgress: boolean
  children?: ReactNode
}

export interface FormData {
  email: string
  password: string
  code?: string
  ttl?: SessionDuration
}

export enum SessionDuration {
  HOUR = '1h',
  DAY = '1d',
  MONTH = '1m',
  YEAR = '1y',
}
